document.addEventListener("DOMContentLoaded", function () {
  // 保存所有实例
  const swipers = [];

  // 初始化所有 collection-swiper（同一页面内的所有）
  document
    .querySelectorAll(".home-safety-solution .collection-swiper")
    .forEach((swiperEl) => {
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 14,
        loop: false,
        observer: true, // 监听自身DOM变化
        observeParents: true, // 监听父容器变化（关键：当 area-info 从 display:none -> block 时会触发重算）
        navigation: {
          nextEl: swiperEl.querySelector(".swiper-button-next") || undefined,
          prevEl: swiperEl.querySelector(".swiper-button-prev") || undefined,
        },
        pagination: {
          el: swiperEl.querySelector(".swiper-pagination"),
          type: "progressbar", // 启用进度条
        },
        breakpoints: {
          1440: {
            //当屏幕宽度小于等于1440
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1200: {
            //当屏幕宽度小于等于1200
            slidesPerView: 2,
            spaceBetween: 14,
          },
        },
      });
      // 让进度条可点击
      const progressEl = swiperEl.querySelector(".swiper-pagination");
      progressEl.addEventListener("click", (e) => {
        const rect = progressEl.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const progress = clickX / rect.width; // 点击位置比例
        const newIndex = Math.floor(progress * swiper.slides.length); // 计算对应 slide
        swiper.slideTo(newIndex);
      });

      // 存起来，后面切换时用
      swipers.push({ el: swiperEl, instance: swiper });
    });

  // ========== 切换 area (左侧 area-title) ==========
  const areaTitles = document.querySelectorAll(
    ".home-safety-solution .area-title"
  );
  const areaInfos = document.querySelectorAll(
    ".home-safety-solution .area-info"
  );

  function activateAreaByIndex(index) {
    areaTitles.forEach((i) => i.classList.remove("active"));
    areaInfos.forEach((i) => i.classList.remove("active"));

    const activeTitle = areaTitles[index];
    if (!activeTitle) return;

    const areaHandle = activeTitle.getAttribute("data-area");
    const targetArea = document.querySelector(
      `.home-safety-solution .area-info[data-area="${areaHandle}"]`
    );

    // 更新背景图
    const bgUrl = activeTitle.dataset.bg;
    const leftHouse = document.querySelector(
      ".home-safety-solution .left-house"
    );
    if (bgUrl && leftHouse) {
      leftHouse.style.backgroundImage = `url(${bgUrl})`;
    }

    // 激活状态切换
    activeTitle.classList.add("active");
    if (targetArea) {
      targetArea.classList.add("active");

      const activeSwiperEl = targetArea.querySelector(".collection-swiper");
      if (activeSwiperEl) {
        const found = swipers.find((s) => s.el === activeSwiperEl);
        if (found) {
          setTimeout(() => {
            found.instance.update();
            found.instance.slideTo(0);
          }, 50);
        }
      }
    }
  }

  areaTitles.forEach((item, idx) => {
    item.addEventListener("click", () => activateAreaByIndex(idx));
  });

  // ========== 切换 collection title -> product-grid （每个 area 内） ==========
  document
    .querySelectorAll(".home-safety-solution .area-info")
    .forEach((area) => {
      const titles = area.querySelectorAll(".collection-title");
      const productGrids = area.querySelectorAll(".product-grid");

      titles.forEach((title) => {
        title.addEventListener("click", () => {
          const handle = title.dataset.collection;

          // 1. 切换 title 的 active 状态（同一 area 下）
          titles.forEach((t) => t.classList.remove("active"));
          title.classList.add("active");

          // 2. 切换 product-grid 的显示
          productGrids.forEach((grid) => {
            const isMatch = grid.dataset.collection === handle;
            grid.classList.toggle("active", isMatch);

            if (isMatch) {
              // 找到该 grid 下的 swiper 并 update
              const swiperEl = grid.querySelector(".collection-swiper");
              if (swiperEl) {
                const found = swipers.find((s) => s.el === swiperEl);
                if (found) {
                  // 小延迟以保证 display 切换生效
                  setTimeout(() => {
                    found.instance.update();
                    found.instance.slideTo(0);
                  }, 50);
                }
              }
            }
          });
        });
      });
    });

  // 页面首次加载时，确保第一个 area/collection 的 swiper 更新（保险）
  const firstArea = document.querySelector(
    ".home-safety-solution .area-info.active"
  );
  if (firstArea) {
    const firstSwiperEl =
      firstArea.querySelector(".product-grid.active .collection-swiper") ||
      firstArea.querySelector(".collection-swiper");
    if (firstSwiperEl) {
      const found = swipers.find((s) => s.el === firstSwiperEl);
      if (found) {
        setTimeout(() => {
          found.instance.update();
        }, 50);
      }
    }
  }

    // ===== 统一所有 swiper-wrapper 高度 =====
  function setUniformSwiperHeights() {
    const wrappers = document.querySelectorAll(
      ".home-safety-solution .collection-swiper .swiper-wrapper"
    );
    if (!wrappers.length) return;

    // 重置，避免重复叠加
    wrappers.forEach(wrapper => (wrapper.style.height = "auto"));

    // 计算最高高度
    let maxHeight = 0;
    wrappers.forEach(wrapper => {
      const h = wrapper.scrollHeight;
      if (h > maxHeight) maxHeight = h;
    });

    // 应用统一高度
    wrappers.forEach(wrapper => {
      wrapper.style.height = `${maxHeight}px`;
    });
  }

  // 页面加载后执行一次
  window.addEventListener("load", setUniformSwiperHeights);
  // 监听窗口变化（响应式布局时重算）
  window.addEventListener("resize", setUniformSwiperHeights);

});
